// src/components/ui/LoadingOverlay/index.tsx
import React, { useEffect, useState } from "react";
import { DualRing } from "react-spinners-css";
import { useTheme } from "styled-components";
import { Overlay, Card, Label } from "./styles";

interface LoadingOverlayProps {
  show: boolean;
  /** Texto opcional abaixo do spinner (ex.: "Enviando pedido..."). */
  label?: string;
}

/**
 * Overlay de carregamento com fade suave, para ações rápidas (submits,
 * refetches). Para primeiro carregamento de tela, prefira Skeleton.
 */
export default function LoadingOverlay({ show, label }: LoadingOverlayProps) {
  const theme = useTheme();
  const [mounted, setMounted] = useState(show);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (show) {
      setMounted(true);
      const t = setTimeout(() => setShown(true), 20);
      return () => clearTimeout(t);
    }
    setShown(false);
    const t = setTimeout(() => setMounted(false), 280);
    return () => clearTimeout(t);
  }, [show]);

  if (!mounted) return null;

  return (
    <Overlay data-testid="loading-overlay" $shown={shown}>
      <Card $shown={shown}>
        <DualRing color={theme.tokens.colors.teal} size={44} />
        {label && <Label>{label}</Label>}
      </Card>
    </Overlay>
  );
}
